module.exports = __webpack_public_path__ + "static/media/arrow-down.c8122c7b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/arrow-down.svg
// module id = 748
// module chunks = 0